import React from "react";
import { useTranslation } from "react-i18next";
import { useRemoveProjectReport } from "@planzone/view-models";
import { Modal } from "@common/modal";
import { Button } from "@common/button";
import { Props } from "./types";
import styles from "./styles.scss";

function ProjectReportRemoval({ projectReport, project, cancel }: Props) {
  const { t } = useTranslation();
  const { isRequestPending, removeProjectReport } =
    useRemoveProjectReport(projectReport);

  return (
    <Modal
      header={t("removeProjectReport.title")}
      headerClassName={styles.header}
      close={cancel}
    >
      <div className={styles.main}>
        <div className={styles.group}>
          <p className={styles.text}>{t("removeProjectReport.group")}</p>
          <p className={styles.name}>{`> ${projectReport.name}`}</p>
          <p className={styles.text}>{t("removeProjectReport.removal")}</p>
        </div>
        <div className={styles.buttons}>
          <Button type="cancel" press={cancel}>
            {t("removeProjectReport.cancel")}
          </Button>
          <Button
            type="delete"
            status={isRequestPending ? "pending" : "none"}
            press={() =>
              removeProjectReport({ report: projectReport, project })
            }
          >
            {t("removeProjectReport.confirm")}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export { ProjectReportRemoval };
